<div class="related-container">
  <div class="custom-mat-spinner" *ngIf="isSpinnerShown"> 
    <mat-spinner></mat-spinner>
    <div class="text">Data loading...</div>
  </div>

  <div *ngIf="!isSpinnerShown">

    <!-- Automations -->
    <section class="automations">
      <div class="block-title">
        <span (click)="isAutomationsExpanded = !isAutomationsExpanded">Automations</span>
        <span  class="shevron" (click)="isAutomationsExpanded = !isAutomationsExpanded">
          <img [ngClass]="isAutomationsExpanded ? 'img-up' : ''" src="../../../../assets/img/invoiceForm/shevron.svg" alt="">
        </span>
      </div>
      <div class="block-content" *ngIf="isAutomationsExpanded" [ngClass]="isAutomationsExpanded ? 'expaned' : ''">
        <div class="setting-line">
          <div class="caption">Auto-publish</div>
          <div class="switcher form-check form-switch">
            <input class="form-check-input" type="checkbox" role="switch" [(ngModel)]="isAutoPublishOn" (change)="changeAutoPublishSetting($event)">
          </div>
        </div>
        <div class="setting-line">
          <div class="caption">Auto-approve</div>
          <div class="switcher form-check form-switch" style="width: fit-content; height: fit-content;" [matTooltip]="autoApprover ? '' : 'Select an approver first'"
            [matTooltipShowDelay]="showToolTipDelay">
            <input class="form-check-input" type="checkbox" role="switch" [disabled]="!autoApprover" [ngModel]="isAutoApprovalOn" 
              (change)="changeAutoApprovalSetting($event)">
          </div>
        </div>
        <div class="users" *ngIf="relatedData?.organization?.users?.length > 0" >
          <div class="title" *ngIf="autoApprover">
            <span>Approver:</span>
            <span class="user">{{autoApprover?.name}} - {{autoApprover?.email}}</span>
          </div>
          <div class="title">Select a user for approval</div>
          <ul>
            <li class="user activity" *ngFor="let user of relatedData?.organization?.users" (click)="selectUserForAutoApproval(user)">
              {{user.name}} - {{user.email}}
            </li>
          </ul>
        </div>
      </div>
    </section>

    <!-- Accounting Integration -->
    <section class="accounting" *ngIf="!relatedData?.organization?.isNoAccounting">
      <div class="block-title">
        <span  (click)="isAccountingExpanded = !isAccountingExpanded">
          <span *ngIf="!relatedData?.organization?.isQBO">Xero</span>
          <span *ngIf="relatedData?.organization?.isQBO">QuickBooks</span>
        </span>
        <span class="shevron" (click)="isAccountingExpanded = !isAccountingExpanded">
          <img [ngClass]="isAccountingExpanded ? 'img-up' : ''" src="../../../../assets/img/invoiceForm/shevron.svg" alt="">
        </span>
      </div>
      <div class="block-content" *ngIf="isAccountingExpanded" [ngClass]="isAccountingExpanded ? 'expaned' : ''">
        <div class="acc-type">
          <div class="logo-container">
            <div class="accounting-logo">
              <img *ngIf="!relatedData?.organization?.isQBO" class="act-logo" src="../../../../assets/img/company/XeroLogo.svg" alt=""/>
              <img *ngIf="relatedData?.organization?.isQBO" class="act-logo" src="../../../../assets/img/company/QBOLogo.png" alt=""/>
            </div>
          </div>
          <div class="desc">
            <div class="title">{{supplier?.name}}</div>
            <div class="subtitle" *ngIf="relatedData?.organization?.firstName || relatedData?.organization?.lastName || relatedData?.organization?.email">
              <span>{{relatedData?.organization?.firstName}}&nbsp;{{relatedData?.organization?.lastName}}</span>
              <span *ngIf="relatedData?.organization?.email">&nbsp;-&nbsp;{{relatedData?.organization?.email}}</span>
            </div>
          </div>
          <a class="img-goto" href="{{link}}" target="_blank" [matTooltip]="relatedData?.organization?.isQBO ? 'Go to QuickBooks' : 'Go to Xero'"
            [matTooltipShowDelay]="showToolTipDelay">
            <img src="../../../../assets/img/invoiceForm/goto.svg" alt=""/>
          </a>
        </div>
        <div *ngIf="!relatedData?.organization?.isQBO" class="xero-history-link-row">
          <a (click)="loadXeroHistory()" class="xero-history-link">
            {{ isXeroHistoryShown ? 'Hide Xero History' : 'See Xero History' }}
          </a>
        </div>
        <div *ngIf="isXeroHistoryShown && !relatedData?.organization?.isQBO" class="xero-history-panel">
          <div *ngIf="isXeroHistoryLoading" class="xero-history-loading">Loading...</div>
          <div *ngIf="!isXeroHistoryLoading && xeroHistory.length == 0" class="xero-history-empty">No Xero history found.</div>
          <div *ngFor="let item of xeroHistory" class="xero-history-item">
            <div class="xero-history-item-changes">{{ item.changes }}</div>
            <div class="xero-history-item-meta">{{ item.user }} &middot; {{ item.dateUTC | date:'dd MMM yyyy, h:mm a' }}</div>
            <div *ngIf="item.details" class="xero-history-item-details">{{ item.details }}</div>
          </div>
        </div>
      </div>
    </section>
  </div>
</div>
